import React, { useMemo } from 'react';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';
import ProductPrices from '../../../../components-legacy/ProductPrices';
import { FlagType } from '../../../../../@types/product.enum';

export default function Price() {
  const { flags, price } = useContext(ProductContext);

  const priceDesign = useMemo(() => {
    const featureFlag = flags.find((i) => i.type === FlagType.featured);
    if (featureFlag) return featureFlag.priceCustomization;

    const priceFlag = flags.find((i) => i.type === FlagType.price);
    if (priceFlag) return priceFlag.priceCustomization;

    const mainFlag = flags.find((i) => i.type === FlagType.main);
    return mainFlag?.priceCustomization;
  }, [flags]);

  const hasPriceFlag = useMemo(() => flags?.some((flag) => flag.type === FlagType.price), [flags]);

  if (!price) {
    return null;
  }

  return (
    <>
      <ProductPrices
        size="large"
        priceDesign={priceDesign}
        priceObject={{
          originalPrice: price.originalPrice,
          sellingPrice: price.price,
          referencePrice: price.referencePrice,
          pilPrice: price.pilPrice,
          componentPrice: price.componentPrice,
        }}
        hasPriceFlag={hasPriceFlag}
      />
    </>
  );
}
